import {FC, Dispatch, SetStateAction, useState} from 'react'
import * as Yup from 'yup'
import {Formik, Field, Form} from 'formik'
import {updateUserEmail} from '../../core/_requests'
import {User} from '../../core/_models'
import {handleErrors} from '@/components/form/_utils'
import {
  InputText,
  FormActions
} from '@/components/form'
import {Alert} from '@/components/Alert'

type Props = {
  user: User
  refreshUser: Dispatch<SetStateAction<User|undefined>>
  confirm: boolean
  setShowEmailForm: Dispatch<SetStateAction<boolean>>
}

const EmailForm: FC<Props> = ({user, refreshUser, confirm, setShowEmailForm}) => {
  const [error, setError] = useState<string|undefined>()
  const [message, setMessage] = useState<string|undefined>()
  const schema = Yup.object({
    email: Yup.string().email().min(3, 'Minimum 3 characters').required('Email is required'),
    password: Yup.string().when('confirm', {
      is: () => confirm === true,
      then: (schema) => schema.min(8, 'min 8 chars').required(),
      otherwise: (schema) => schema.notRequired()
    })
  })

  return (
    <Formik
      initialValues={{...user, confirm}}
      validationSchema={schema}
      onSubmit={async (values, {setErrors}) => {
        try {
          refreshUser(await updateUserEmail({ ...user, ...values }, confirm))
          setMessage('Your email has been updated')
        } catch (e: any) {
          handleErrors(e, setErrors)
          if (e?.response?.status !== 400) {
            setError(e?.response?.status + ' ' + e?.response?.statusText)
            console.log(error)
          }
        }
      }}
    >
      {({values}) => (
        <Form className='form'>
          {error && (
            <Alert type="danger" icon="information" title="An error happened!" message={error} />
          )}

          {message && (
            <Alert type="success" icon="check-circle" title="Success" message={message} />
          )}
          <div className={'row'}>
            <div className={`col-${confirm ? '6' : '12'}`}>
              <Field
                name="email"
                type="email"
                component={InputText}
                label="Email"
                required={true}
              />
            </div>
            {confirm && (
              <div className="col-6">
                <Field
                  name="password"
                  type="password"
                  component={InputText}
                  label="Type your password"
                  required={true}
                />
              </div>
            )}
          </div>

          <Field
            component={FormActions}
            padding="pt-0"
            position="text-start"
            close={() => {
              setShowEmailForm(false)
              setMessage(undefined)
              setError(undefined)
            }}
          />
        </Form>
      )}
    </Formik>
  )
}

export {EmailForm}
